const stats = [
  { number: "15,000+", label: "Products Listed" },
  { number: "500+", label: "QC Guides" },
  { number: "50+", label: "Buying Tutorials" },
  { number: "Weekly", label: "Spreadsheet Updates" },
];

export default function StatsSection() {
  return (
    <section className="w-full py-12 md:py-16 bg-background-50">
      <div className="max-w-5xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-primary-500 font-heading mb-2">
                {stat.number}
              </div>
              <p className="text-sm md:text-base text-foreground-600 font-medium">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}